import { CalculationSettingsModel, RNAVModel } from './configuration';
import { NavaidDTOCalculation } from './navaid';

export class coverageDTO {

  minAltitude: number;
  maxAltitude: number;
  useAltitudeAboveGround : boolean;
  altitudeAboveGround : number;
  altitudeInterval: number;
  isCoverageAssessmentTool : boolean = false;
  rangeLimitation : string;
  propagationType : number;
  useFSPL : boolean;
  name: string;
  navaids: NavaidDTOCalculation[] = [];
  calculationSettings: CalculationSettingsModel;
  rnav: RNAVModel;
  projectId: number;
  supressOverlappingPolygons: boolean;
}

export class coverageDTOModal {

  calculationName:string;
  singleAltitude : number;
  singleAltitudeMeters : number;
  minAltitude: number;
  minAltitudeMeters: number;
  maxAltitude: number;
  maxAltitudeMeters: number;
  altitudeInterval: number;
  altitudeIntervalMeters: number;
  isSingleLevel : boolean = false;
  supressOverlappingPolygons:boolean = false;
  constructor(){
    this.isSingleLevel = false;
  }
}

export class coverageAssessmentToolDTOModal {

  calculationName:string;
  propagationType:string;
  rangeLimitation:string;
  calculationType:string;
  coverageAlgorithm:string;
  singleAltitude : number;
  singleAltitudeMeters : number;
  minAltitude: number;
  minAltitudeMeters: number;
  maxAltitude: number;
  maxAltitudeMeters: number;
  altitudeInterval: number;
  altitudeIntervalMeters: number;
  useAltitudeAboveGround : boolean;
  altitudeAboveGround : number;
  altitudeAboveGroundMeters : number;
  isSingleLevel : boolean = false;

  constructor(){
    this.isSingleLevel = false;
  }
}
